<template>
  <div class="collection">
    <banners v-if="isPresent(banners)" :banners="banners" />
    <div class="banner-message"></div>
    <div class="container">
      <div class="content">
        <div
          v-if="!isPresent(banners)"
          class="page-header page-header--left page-header--small"
        >
          <h1 class="taxon-title">
            {{ name }}
          </h1>
        </div>
        <div ref="topHtml"></div>
        <div class="section section--universal">
          <products-grid
            v-if="products.length"
            :products="products"
            :max-grid-columns="4"
            :mobile-max-grid-columns="2"
            class="catalog clearfix"
          />
          <div v-else class="info-panel info-panel--solo">
            <p>{{ $t('collections.no_products') }} 😔</p>
          </div>
        </div>
        <div ref="bottomHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
import isPresent from '~/utils/isPresent'
import Banners from '~/components/pages/banners/Banners.vue'
import ProductsGrid from '~/components/ProductsGrid.vue'

export default {
  components: { Banners, ProductsGrid },
  props: {
    collection: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  computed: {
    banners() {
      return this.collection?.banners || []
    },
    name() {
      // eslint-disable-next-line camelcase
      return this.collection?.name
    },
  },
  mounted() {
    const { top_html: topHtml, bottom_html: bottomHtml } = this.collection
    if (topHtml) this.$refs.topHtml.innerHTML = topHtml
    if (bottomHtml) this.$refs.bottomHtml.innerHTML = bottomHtml
  },
  methods: {
    isPresent,
  },
}
</script>

<style lang="scss">
@import '~/assets/css/_content.scss';
</style>
